var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"bg-light text-dark",attrs:{"size":_vm.size},on:{"click":_vm.mylogout}},[_vm._v("\n  "+_vm._s(_vm.mylogout_text())+"\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }